module.exports = __webpack_public_path__ + "static/media/laxmirajdryfruits.63b3fefa.jpg";